import Vue from 'vue/dist/vue.esm.js'
import { evaluate } from 'mathjs/number'

window.ReportRowConfig =
  wait: 2000

Vue.component('report-rows-invoice-row',
  template: JST['report_rows/invoice_row']()
  props: ['reportRow', 'rowsCollection']
  store: KCVS.Stores.ReportRowsStore
  created: ->
    @updateRow = _.debounce(@updateRow, ReportRowConfig.wait)

  mounted: ->
    @updateErrorTooltip()

  data: ->
    errors: {}
    row: @reportRow
    processing: false
    expressionError: false

  computed:
    expense_type: ->
      if @row.expense_type
        I18n.t("translatable_attributes.report_row.project_types.#{@row.expense_type}")

    state: ->
      if @row.state
        I18n.t("translatable_attributes.report_row.states.#{@row.state}")

    readOnly: ->
      return @$store.state.periodClosed

    paymentDate: ->
      paymentDateParts = @row.payment_date.split('-')
      return new Date(paymentDateParts[2], paymentDateParts[1], paymentDateParts[0])

    expenseDate: ->
      expenseDateParts = @row.expense_document_date.split('-')
      return new Date(expenseDateParts[2], expenseDateParts[1], expenseDateParts[0])

    periodStartDate: ->
      periodStartDateParts = @row.period_start_date.split('-')
      return new Date(periodStartDateParts[2], periodStartDateParts[1], periodStartDateParts[0])

    periodEndDate: ->
      periodEndDateParts = @row.period_end_date.split('-')
      return new Date(periodEndDateParts[2], periodEndDateParts[1], periodEndDateParts[0])

    rowId: ->
      "row-#{@row.id}"

    rowChecked:
      get: ->
        return _.indexOf(@$store.state.selectedInvoiceRowIds, @row.id) > -1
      set: (val) ->
        if val
          @$store.commit('addInvoiceRowId', @row.id)
        else
          @$store.commit('removeInvoiceRowId', @row.id)

    smallerThanApplicableAmount: ->
      return parseFloat(@row.payment_document_amount) < parseFloat(@row.applicable_amount)

    smallerThanTotalAmount: ->
      return parseFloat(@row.payment_document_amount) < parseFloat(@row.total_amount)

    missingInputFieldValues: ->
      return !@row || !@row.payment_document_amount ||
        !(@row.payment_document_amount.length > 0) ||
       !@row.payment_date || !(@row.payment_date.length > 0) ||
       !@row.payment_document_number || !(@row.payment_document_number.length > 0)

    paymentDateNotInPeriodRange: ->
      return this.paymentDate < this.periodStartDate || this.paymentDate > this.periodEndDate

    documentDateBiggerThanPaymentDate: ->
      return this.paymentDate < this.expenseDate

    isProblematic: ->
      @row.state == 'problematic'

    totalPaymentAndApplicableAndTotalAmounts: ->
      samePaymentDocRows = _.filter(@rowsCollection, (row) =>
        row.payment_document_number == @row.payment_document_number &&
        row.payment_date == @row.payment_date &&
        row.payment_document_amount == @row.payment_document_amount
      )
      return [] if samePaymentDocRows.length < 2

      paymentDocApplicableAmounts = _.map(samePaymentDocRows, 'applicable_amount')
      paymentDocTotalAmounts = _.map(samePaymentDocRows, 'total_amount')
      paymentDocTotalPaymentAmounts = samePaymentDocRows.map((row) =>
        parseFloat(row.payment_document_amount).toFixed(2) || 0
      )
      paymentDocTotalApplicableAmount = _.reduce(
        paymentDocApplicableAmounts, (memo, amount) ->
          memo + parseFloat(amount)
        , 0
      )
      paymentDocTotalTotalAmount = _.reduce(
        paymentDocTotalAmounts, (memo, amount) ->
          memo + parseFloat(amount)
        , 0
      )
      [
        parseFloat(paymentDocTotalApplicableAmount.toFixed(2)),
        parseFloat(paymentDocTotalTotalAmount.toFixed(2)),
        paymentDocTotalPaymentAmounts
      ]

    smallerThanApplicableSum: ->
      amounts = @totalPaymentAndApplicableAndTotalAmounts
      if amounts.length
        isPaymentAmountSmaller = amounts[2].find((paymentAmount) =>
          amounts[0] > paymentAmount
        )
        if isPaymentAmountSmaller
          return true
        else
          return false

    smallerThanTotalSum: ->
      amounts = @totalPaymentAndApplicableAndTotalAmounts
      if amounts.length
        isPaymentAmountSmaller = amounts[2].find((paymentAmount) =>
          amounts[1] > paymentAmount
        )
        if isPaymentAmountSmaller
          return true
        else
          return false

    applyCorrectErrorColor: ->
      switch true
        when @smallerThanApplicableAmount then "smaller-than-applicable-amount"
        when @smallerThanTotalAmount then "smaller-than-total-amount"
        when @smallerThanApplicableSum then "smaller-than-applicable-amount-sum"
        when @smallerThanTotalSum then "smaller-than-total-amount-sum"
        when @missingInputFieldValues then "missing-input-field-values"
        when @paymentDateNotInPeriodRange then "payment-date-not-in-period-range"
        when @documentDateBiggerThanPaymentDate then "expense-date-bigger-than-payment-date"
        when @isProblematic then "is-problematic"
        else null

    fillErrorMessages: ->
      conditions = [
        { condition: @smallerThanApplicableAmount, \
          messageKey: \
          "activerecord.errors.report_rows.messages.payment_document_amount_smaller_than_applicable_amount"},
        { condition: @smallerThanTotalAmount, \
          messageKey: \
          "activerecord.errors.report_rows.messages.payment_document_amount_smaller_than_total_amount"},
        { condition: @smallerThanApplicableSum, \
          messageKey: \
          "activerecord.errors.report_rows.messages.payment_amount_sum_smaller_than_applicable_amount_sum"},
        { condition: @smallerThanTotalSum, \
          messageKey: \
          "activerecord.errors.report_rows.messages.payment_amount_sum_smaller_than_total_amount_sum"},
        { condition: @missingInputFieldValues, \
          messageKey: \
          "activerecord.errors.report_rows.messages.missing_input_field_values"},
        { condition: @paymentDateNotInPeriodRange, \
          messageKey: \
          "activerecord.errors.report_rows.messages.payment_date_not_in_period_range"},
        { condition: @documentDateBiggerThanPaymentDate, \
          messageKey: \
          "activerecord.errors.report_rows.messages.expense_date_bigger_than_payment_date"},
        { condition: @isProblematic, \
          messageKey: \
          "activerecord.errors.report_rows.messages.is_problematic"}
      ]

      errorTooltipMessages = ''

      for {condition, messageKey} in conditions
        if condition
          errorTooltipMessages = errorTooltipMessages.concat(
            "<p>#{I18n.t(messageKey)}</p>"
            )

      return errorTooltipMessages

  watch:
    'row.problem_notes': -> # This needs to be before row watcher,
                            # to change the state before ajax update
      @row.problem_notes = @row.problem_notes.replace('\n', ' ')
      if @row.problem_notes
        @row.state = 'problematic'
      else
        @row.state = 'approved'
    row:
      handler: -> @updateRow()
      deep: true

    fillErrorMessages:
      handler: ->
        @updateErrorTooltip()

  methods:
    evaluatePaymentAmount: ->
      expression = @row.payment_document_amount?.trim()
      unless expression
        @expressionError = false
        return

      @expressionError = false
      try
        result = evaluate(expression)
        if typeof result == 'number' && isFinite(result) && result.toString() != expression
          formatted = parseFloat(result.toFixed(2))
          @row.payment_document_amount = formatted.toString()
      catch error
        @expressionError = true
        @errors = { payment_document_amount: [I18n.t('javascript.invalid_math_expression')] }
        return

    updateErrorTooltip: ->
      element = @$el.querySelectorAll('[data-toggle="tooltip"]')[0]
      element.setAttribute('data-original-title', @fillErrorMessages)
      $(element).tooltip({
        template: '<div class="tooltip custom-error-tooltip" role="tooltip"> \
            <div class="tooltip-arrow"></div> \
            <div class="tooltip-inner"></div> \
          </div>'
      })

    focusOnOtherInput: (e) ->
      switch e.keyCode
        when 40 # Down arrow
          nextRow = $(@$el).next('tr')
          currentInputName = $(e.target).attr('name')
          nextRow.find("[name='#{currentInputName}']").focus()
        when 13 #Enter
          nextRow = $(@$el).next('tr')
          currentInputName = $(e.target).attr('name')
          nextRow.find("[name='#{currentInputName}']").focus()
        when 38 # Up arrow
          nextRow = $(@$el).prev('tr')
          currentInputName = $(e.target).attr('name')
          nextRow.find("[name='#{currentInputName}']").focus()
        when 37 # Left arrow
          $(e.target).parents('td').prev().find('input', 'textarea').focus()
        when 39 # Right arrow
          if $(e.target).parents('td').next().length > 0 # Not last input in the row
            $(e.target).parents('td').next().find('input', 'textarea').focus()
          else
            $(@$el).next('tr').find('td input').first.focus()

    updateRow: ->
      return if @readOnly
      return if @expressionError
      @errors = {}
      @$store.dispatch('updateInvoiceRow', @row)
      .then(() =>
        Helper.flashRow($(@$el), '#bfdf9f')
      )
      .catch((data) =>
        @errors = data.responseJSON
        Helper.flashRow($(@$el), '#d10404')
      )

    destroy: ->
      # don't run request twice if button is quickly pressed more than once
      return if @processing || @readOnly
      if confirm I18n.t("javascript.row_delete_confirmation")
        @processing = true
        @$store.dispatch('destroyInvoiceRow', @row)
)
